export interface Disposables {
  add(callback: () => void): void
  dispose(): void
  nextFrame(...args: Parameters<typeof requestAnimationFrame>): void
  requestAnimationFrame(...args: Parameters<typeof requestAnimationFrame>): void
  setTimeout(...args: Parameters<typeof setTimeout>): void
}

function createDisposables(): Disposables {
  const disposables: (() => void)[] = []

  return {
    add(callback: () => void) {
      disposables.push(callback)
    },

    dispose() {
      for (const disposable of disposables.slice(0)) {
        disposable()
      }
    },

    nextFrame(...args: Parameters<typeof requestAnimationFrame>) {
      this.requestAnimationFrame(() => {
        this.requestAnimationFrame(...args)
      })
    },

    requestAnimationFrame(...args: Parameters<typeof requestAnimationFrame>) {
      const raf = requestAnimationFrame(...args)

      this.add(() => cancelAnimationFrame(raf))
    },

    setTimeout(...args: Parameters<typeof setTimeout>) {
      const timer = setTimeout(...args)

      this.add(() => clearTimeout(timer))
    },
  }
}

export default createDisposables
